// hooks/useItemsPerView.ts
import { useEffect, useState } from "react";

export function useItemsPerView() {
  const [itemsPerView, setItemsPerView] = useState(4);

  useEffect(() => {
    const updateItemsPerView = () => {
      const width = window.innerWidth;
      if (width < 640) setItemsPerView(2);        // Small screens
      else if (width < 1024) setItemsPerView(3);   // Medium screens
      else setItemsPerView(4);                     // Large screens
    };

    updateItemsPerView();
    window.addEventListener("resize", updateItemsPerView);
    return () => window.removeEventListener("resize", updateItemsPerView);
  }, []);

  return itemsPerView;
}
